//@flow
import * as React from 'react'
import { Component } from 'react'

type NodeRequire = (id: string) => any

type NoSSRProps = {
  children: (lib: any) => React.Node,
  requireFunc: () => NodeRequire
}

type NoSSRState = {
  lib: any,
  ssrActive: boolean
}

class NoSSR extends Component<NoSSRProps, NoSSRState> {
  state = {
    lib: null,
    ssrActive: true
  }

  componentDidMount() {
    this.setState({
      ssrActive: false,
      lib: this.props.requireFunc()
    })
  }

  render() {
    const { ssrActive, lib } = this.state
    return !ssrActive ? this.props.children(lib) : null
  }
}

export default NoSSR
